import { createAlertBagStore, type AlertBagStore } from "../../../rx/store/AlertBag"
import getSetEngineWeakMapFactory from "./getSetEngineWeakMapFactory"

type EngineAlertBag = AlertBagStore

export const [getEngineAlertBag, setEngineAlertBag] = getSetEngineWeakMapFactory<EngineAlertBag>(createAlertBagStore)
